import { MarketplaceLinkType, ReviewableLinkType } from "../types";

/**
 * Array of possible marketplace link types ordered by popularity
 */
const marketplaceTypes: MarketplaceLinkType[] = [
  "openSea",
  "foundation",
  "objkt",
  "knownOrigin",
  "magicEden",
  "rarible",
  "superRare",
  "other marketplace",
];

/**
 * Array of possible link types ordered alphabetically
 */
const linkTypes: ReviewableLinkType[] = [
  "discord",
  "etherscan",
  "foundation",
  "instagram",
  "knownOrigin",
  "linkedin",
  "magicEden",
  "medium",
  "nifty",
  "objkt",
  "openSea",
  "rarible",
  "reddit",
  "superRare",
  "telegram",
  "tiktok",
  "twitter",
  "website",
  "youtube",
];

export { linkTypes, marketplaceTypes };
